
import { mapState } from 'vuex'
import DescriptionAndDefects from '@/components/catalog/product/details/DescriptionAndDefects'
import AttributeGroupTable from '@/components/catalog/product/details/AttributeGroupTable'
import Damages from '@/components/catalog/product/images/Damages'

export default {
  name: 'TrailerDetailsCards',
  components: { Damages, AttributeGroupTable, DescriptionAndDefects },
  data: () => {
    return {
      tabProfile: 0,
      tabEquipment: 0,
      tabTitleClass: 'text-h6'
    }
  },
  computed: {
    ...mapState('customer', {
      merchantAcceptedByCm24 (state) {
        if (state.merchant.acceptedByCm24) {
          return state.merchant.acceptedByCm24 === true
        } else {
          return false
        }
      }

    }),

    ...mapState('product', {
      product: state => state.data,
      damagesExists: state => state.data?.damages?.length > 0,
      defectsExists: (state) => {
        if (state.data?.attributes) {
          const found = Object.values(state.data?.attributes)?.find(attribute => attribute.attributeCode === 'defects_exists')
          if (found) {
            return found?.optionLabel?.toLowerCase() === 'ja'
          } else {
            return false
          }
        } else {
          return false
        }
      }

    })
  }

}
